import api from "api";
import React, { Fragment, useEffect, useState } from "react";
import Header from '../../component/Header/Header'
import Footer from '../../component/Footer/Footer.js';
import HomeSlider from '../../component/HomeSlider/HomeSlider';
import BlockHeader from '../../component/BlockHeader/BlockHeader';
import stateMap from "../../store/stateMap";
import { connect } from 'react-redux';
import { NotifList } from "component/Notif";
import {useSearchParams, useNavigate } from "react-router-dom";
import { popinfo } from "component/Fancybox/Fancybox";
import { PageCredential } from "component/PageCredential";

const PageNotification = connect(stateMap)((props) => {
    let navigate                                = useNavigate();
    let [searchParams]                          = useSearchParams();
    const NotifID                               = searchParams.get('nid');

    useEffect(() => {
        
        if(!props.auth.user)
        {
            return;
        }

        if(NotifID)
        {
            api('/Notif/RedirectTo', 'get', {
                notif_id : NotifID
            }, 'Bearer ' + props.auth.token)
                .then(response => {
                    navigate({
                        pathname    : response.path_location.pathname
                        ,search     :  response.path_location.search
                    });
                })
                .catch(error => {
                    popinfo('error', 'Error Loading Notification', error);
                })
        }

    }, [props.auth.user, NotifID])

    return (
        <>
            <Header/>
                <PageCredential title="Notification"/>
                {
                    props.auth.user && !NotifID && 
                    <div className="page-notification-archive">
                        <div className="container">
                            <div className="w-800 mx-auto">
                                <BlockHeader title="All Notification"/>

                                <NotifList/>
                            </div>
                        </div>
                    </div>
                }
            <Footer/>
        </>
    )
});

export default PageNotification;